import * as React from 'react';

import { createStackNavigator } from '@react-navigation/stack';

import SplashScreen from "../screens/SplashScreen";
import LoginScreen from "../screens/LoginScreen";
import DrawerNav from "./DrawerNav";
import ProfileScreen from "../screens/ProfileScreen";
import WalletScreen from "../screens/WalletScreen";
import SupportScreen from "../screens/SupportScreen";
import NotifictionScreen from "../screens/NotifictionScreen";
import AboutUsScreen from "../screens/AboutUsScreen";
import RequestListScreen from "../screens/RequestListScreen";
import OrderListScreen from "../screens/OrderListScreen";
import OrderInfoScreen from "../screens/OrderInfoScreen";
import VideoScreen from "../screens/VideoScreen";
import RevenueScreen from "../screens/RevenueScreen";
import RulesScreen from "../screens/RulesScreen";
import {strings} from "../theme/strings";

const Stack = createStackNavigator();

export default function PrimaryNav() {
    return <Stack.Navigator
        headerMode='none'
        initialRouteName="splash">
        <Stack.Screen name="splash" component={SplashScreen} options={{ title: strings.asanDarman }} />
        <Stack.Screen name="login" component={LoginScreen} options={{ title: strings.asanDarman }} />
        <Stack.Screen name="home" component={DrawerNav} options={{ title: strings.asanDarman }} />
        <Stack.Screen name="profile" component={ProfileScreen} options={{ title: strings.asanDarman }} />
        <Stack.Screen name="wallet" component={WalletScreen} options={{ title: strings.asanDarman }} />
        <Stack.Screen name="support" component={SupportScreen} options={{ title: strings.asanDarman }} />
        <Stack.Screen name="notifiction" component={NotifictionScreen} options={{ title: strings.asanDarman }} />
        <Stack.Screen name="aboutus" component={AboutUsScreen} options={{ title: strings.asanDarman }} />
        <Stack.Screen name="requests" component={RequestListScreen} options={{ title: strings.asanDarman }} />
        <Stack.Screen name="orders" component={OrderListScreen} options={{ title: strings.asanDarman }} />
        <Stack.Screen name="orderInfo" component={OrderInfoScreen} options={{ title: strings.asanDarman }} />
        <Stack.Screen name="video" component={VideoScreen} options={{ title: strings.asanDarman }} />
        <Stack.Screen name="revenue" component={RevenueScreen} options={{ title: strings.asanDarman }} />
        <Stack.Screen name="rules" component={RulesScreen} options={{ title: strings.asanDarman }} />
    </Stack.Navigator>
}
